// extracted by mini-css-extract-plugin
module.exports = {"followSearchResultsNavigation__logo":"followSearchResultsNavigation__logo"};